import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';
import Select from '../../../components/ui/Select';

const BulkActionsToolbar = ({ 
  selectedCount, 
  onBulkDelete, 
  onBulkStatusUpdate, 
  onBulkExport,
  onDeselectAll 
}) => {
  const [bulkStatus, setBulkStatus] = useState('');

  const statusOptions = [
    { value: '', label: 'Selecione status...' },
    { value: 'ativo', label: 'Membro ativo' },
    { value: 'inativo', label: 'Membro inativo' },
    { value: 'pendente', label: 'Membro suspenso' },
    { value: 'suspenso', label: 'Membro suspenso' }
  ];

  const handleStatusUpdate = () => {
    if (bulkStatus) {
      onBulkStatusUpdate(bulkStatus);
      setBulkStatus('');
    }
  };

  if (selectedCount === 0) {
    return null;
  }

  return (
    <div className="bg-primary/5 border border-primary/20 rounded-lg p-4 mb-6">
      <div className="flex flex-col lg:flex-row items-start lg:items-center justify-between gap-4">
        <div className="flex items-center space-x-3">
          <div className="flex items-center space-x-2">
            <Icon name="CheckSquare" size={20} className="text-primary" />
            <span className="font-medium text-foreground">
              {selectedCount} member{selectedCount !== 1 ? 's' : ''} selected
            </span>
          </div>
          <Button
            variant="ghost"
            size="sm"
            onClick={onDeselectAll}
            iconName="X"
            iconPosition="left"
          >
            Deselect All
          </Button>
        </div>

        <div className="flex flex-wrap items-center gap-3">
          {/* Status Update */}
          <div className="flex items-center space-x-2">
            <Select
              options={statusOptions}
              value={bulkStatus}
              onChange={setBulkStatus}
              placeholder="Update status..."
              className="min-w-40"
            />
            <Button
              variant="outline"
              size="sm"
              onClick={handleStatusUpdate}
              disabled={!bulkStatus}
              iconName="RefreshCw"
              iconPosition="left"
            >
              Update
            </Button>
          </div>

          {/* Export */}
          <Button
            variant="outline"
            size="sm"
            onClick={onBulkExport}
            iconName="Download"
            iconPosition="left"
          >
            Export Selected
          </Button>

          {/* Delete */}
          <Button
            variant="destructive"
            size="sm"
            onClick={onBulkDelete}
            iconName="Trash2"
            iconPosition="left"
          >
            Delete Selected
          </Button>
        </div>
      </div>
    </div>
  );
};

export default BulkActionsToolbar;